import { render, staticRenderFns } from "./roleControl.vue?vue&type=template&id=2a07e51f&scoped=true"
import script from "./roleControl.vue?vue&type=script&lang=js"
export * from "./roleControl.vue?vue&type=script&lang=js"
import style0 from "./roleControl.vue?vue&type=style&index=0&id=2a07e51f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a07e51f",
  null
  
)

export default component.exports